import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EstatusJSON } from "../../models/EstatusJSON";
import { environment } from '../../../../../environments/environment';
import { IApiBase } from './Interface/IApiBase.interface';
import { CatalogPaginationRequest } from '../../models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from '../../models/Filter/FilterRequest';
import { OnWebCallbackRequest } from '../../models/CallBack/OnWebCallbackRequest';
@Injectable({
    providedIn: 'root'
  })


export class CallbackAPIService implements IApiBase{
  private configUrl: string;

  constructor(
    private http: HttpClient){
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error('Method not implemented.');
  }
  update(datos: any) {
    throw new Error('Method not implemented.');
  }
  delete(id: any) {
    throw new Error('Method not implemented.');
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error('Method not implemented.');
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }

  OnWebCallback(isRequiredUpdateClientId: boolean){
    const request = new OnWebCallbackRequest();
    request.isRequiredUpdateClientId = isRequiredUpdateClientId;
    console.log(this.configUrl + "/api/Callbacks/OnWebCallback");
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Callbacks/OnWebCallback", request);
  }
}
